import { render, staticRenderFns } from "./MetadataAdd.vue?vue&type=template&id=bfccd7d0&scoped=true&"
import script from "./MetadataAdd.vue?vue&type=script&lang=js&"
export * from "./MetadataAdd.vue?vue&type=script&lang=js&"
import style0 from "./MetadataAdd.vue?vue&type=style&index=0&id=bfccd7d0&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bfccd7d0",
  null
  
)

export default component.exports